export default {
  name: "modal",
  props: {
    maxWidth: {
      type: String,
      default: "100%"
    },
    maxHeight: {
      type: String,
      default: "100%"
    },
    noScroll: {
      type: Boolean,
      default: false
    },
    fullHeight: {
      type: Boolean,
      default: false
    },
    isClickMaskClose: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    slotStyle() {
      let result = {
        maxWidth: this.maxWidth,
        maxHeight: this.maxHeight
      };

      if (this.fullHeight) {
        result.height = "100%";
      }

      return result;
    }
  },
  methods: {
    close: function () {
      this.$emit("close");
    },
    ok: function () {
      this.$emit("ok");
    },
    clickMaskClose() {
      if (this.isClickMaskClose) {
        this.close();
      }
    }
  },
  created() {
    document.getElementsByTagName("body")[0].style.overflow = "hidden";
  },
  beforeDestroy() {
    document.getElementsByTagName("body")[0].style.overflow = "auto";
  }
};
